var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero',{attrs:{"id":"hero"}}),_c('about-us',{attrs:{"id":"about-us"}}),_c('AppComparison',{attrs:{"id":"app-comparison"}}),_c('AppsFeatures',{attrs:{"id":"app-features"}}),_c('HowItWorks',{attrs:{"id":"how-it-works"}}),_c('CTA',{attrs:{"id":"cta"}}),_c('ContactUs',{attrs:{"id":"contact-us"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }